export enum SexualOrientation {
  hetero = 'hetero',
  homo = 'homo',
}
